import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[100svh] flex items-center justify-center pt-20 overflow-hidden" data-id="element-126">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/45WxvobAokQSusbztGHirE/mike-scheid-xoYPV4oVQJI-unsplash.jpg")',
      backgroundAttachment: 'fixed'
    }} data-id="element-127">
        {/* Linear top-to-bottom scrim */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to bottom, rgba(14,14,14,0.45) 0%, rgba(14,14,14,0.55) 50%, rgba(14,14,14,0.7) 100%)'
      }} data-id="element-128"></div>
        {/* Radial darkening behind text block */}
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at center, rgba(14,14,14,0.55) 0%, rgba(14,14,14,0.25) 45%, rgba(14,14,14,0) 75%)'
      }} data-id="element-129"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 flex flex-col items-center text-center mt-12 md:mt-0" data-id="element-130">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif text-white mb-6 leading-tight max-w-4xl" data-id="element-131">
          Front Range living,{' '}
          <span className="italic text-brand-silver" data-id="element-132">found.</span>
        </h1>
        <p className="text-lg md:text-xl text-white font-light max-w-2xl mb-10" style={{
        textShadow: '0 1px 12px rgba(0,0,0,0.6)',
        color: 'rgba(255,255,255,0.95)'
      }} data-id="element-133">
          A boutique, locally rooted brokerage guiding buyers and sellers across
          the north Denver metro and foothills.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md sm:max-w-none sm:w-auto" data-id="element-134">
          <button onClick={() => scrollTo('listings')} className="bg-brand-copper hover:bg-brand-copper/90 text-white px-8 h-12 sm:h-14 rounded-lg font-medium transition-colors flex items-center justify-center gap-2 text-base sm:text-lg w-full sm:w-auto" data-id="element-135">
            Browse Listings
            <ArrowRight size={18} data-id="element-136" />
          </button>
          <button onClick={() => scrollTo('valuation')} className="border-2 border-white text-white hover:bg-white hover:text-brand-stone-900 px-8 h-12 sm:h-14 rounded-lg font-medium transition-colors text-base sm:text-lg w-full sm:w-auto" data-id="element-137">
            What's My Home Worth?
          </button>
        </div>

        <p className="text-xs tracking-widest uppercase mt-10 inline-flex px-4 py-2 rounded-full bg-brand-stone-900/40 backdrop-blur-sm border border-white/10" style={{
        color: '#F5F1EA',
        textShadow: '0 1px 12px rgba(0,0,0,0.6)'
      }} data-id="element-138">
          Serving Broomfield, Denver, and the Front Range
        </p>
      </div>
    </section>;
}